export default {
  'order.QueryFailedPleaseTryAgain': '查询失败请重试',
  'order.paymentSuccessful': '支付成功',
  'order.ThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation':
    '支付成功，请返回微信继续操作',
  'order.FailedToGetOrderInformation': '获取订单信息失败',
  'order.AlipayScanCodePayment': '支付宝扫码付款',
  'order.ScanCodePayment': '扫码付',
  'order.Cancel': '取消'
};
